import { Space } from '@/components/Space'
import { Checkbox as AntdCheckbox, type CheckboxOptionType, type CheckboxProps } from 'antd'
import type {
  CheckboxGroupProps as AntdCheckboxGroupProps,
  CheckboxValueType as AntdCheckboxValueType,
} from 'antd/es/checkbox/Group'

export type CheckboxValueType = AntdCheckboxValueType

export type CheckboxOption = CheckboxOptionType

interface CheckboxGroupProps extends Omit<AntdCheckboxGroupProps, 'options'> {
  options: CheckboxOptionType[]
}

export function Checkbox({ children, ...props }: CheckboxProps) {
  return <AntdCheckbox {...props}>{children}</AntdCheckbox>
}

export function CheckboxGroup({ options, ...props }: CheckboxGroupProps) {
  return (
    <AntdCheckbox.Group {...props}>
      <Space direction="vertical">
        {options.map(({ label, ...option }) => (
          <Checkbox key={option.value?.toString()} {...option}>
            {label}
          </Checkbox>
        ))}
      </Space>
    </AntdCheckbox.Group>
  )
}
